module.exports = __webpack_public_path__ + "static/media/YF13_0.db4e3d87.jpg";